const ProductForm = {
  product: null,
  form: null,
  variantOptions: null,
  addToCartButton: null,
  selectedVariant: null,
  buyButton: null,
  variantsData: null,
  sku: null,
  price: null,
  compare_price: null,
  discount: null,
  fixedButton: null,
  fixedPrice: null,
  initForm(product) {
    this.product = product;
    this.form = product.querySelector(".product-form");
    this.variantOptions = this.product.querySelectorAll(
      ".variants-option input"
    );
    this.addToCartButton = product.querySelectorAll(
      ".product-actions .ajax-cart"
    );
    this.variantsData = JSON.parse(
      this.form.querySelector("script[type='application/ld+json']").innerHTML
    );
    this.fixedButton = document.querySelector(".relative-btn");
    this.fixedPrice = document.querySelector(".fixed-atc-price");
    console.log("complete data ", this.variantsData);
    this.registerUiComp();
    Array.from(this.variantOptions).forEach((el, ind) => {
      el.addEventListener("change", this.updateVariant.bind(this));
    });
    this.variantsLoad(product);
  },
  variantsLoad() {
    let selectedVariantId = window.location.search.includes("?variant=")
      ? window.location.search.match(/variant=\d+/)[0].match(/\d+/)[0]
      : "";
    this.selectedVariant = this.variantsData.variants.find(
      (variant) => variant.id == selectedVariantId
    );
    console.log("output is ", this.selectedVariant)
    if(this.selectedVariant.available && this.addToCartButton){
      this.addToCartButton[0].removeAttribute("disabled");
      this.addToCartButton[0].innerHTML = "Add to cart";
      this.fixedButton.removeAttribute("disabled");
      this.fixedButton.innerHTML = "Add to Cart";
      console.log("clicked and working")
    }else{
      this.addToCartButton[0].setAttribute("disabled", "true");
      this.addToCartButton[0].innerHTML = "Out of stock";
      this.fixedButton.setAttribute("disabled", "true");
      this.fixedButton.innerHTML = "Out of Stock";
    }
    this.updateUi();
    this.form.querySelector("input[name='id']").value = this.selectedVariant.id;
  },
  updateVariant() {
    let selectedOptions = Array.from(this.variantOptions)
      .filter((el) => el.checked)
      .map((el) => el.value);
    // console.log("selected option ", selectedOptions);
    // console.log("selected custom ", this.variantsData.variants)
    let selectedVariantData = this.variantsData.variants.filter(
      (el) =>
        el.options.length == selectedOptions.length &&
        el.options.every((opt) => selectedOptions.indexOf(opt) !== -1)
    );
    // console.log("selected variant option ", selectedVariantData);
    if (selectedVariantData.length > 0) {
      let searchQuery = `?variant=${selectedVariantData[0].id}`;
      window.history.pushState({}, "", searchQuery);
      this.selectedVariant = selectedVariantData[0];
      this.variantsLoad();
    } else {
      this.addToCartButton[0].setAttribute("disabled", "true");
      this.addToCartButton[0].innerHTML = "Out of stock";
    }
  },
  updateUi() {
    this.sku ? (this.sku.innerHTML = this.selectedVariant.sku) : "";
    this.price
      ? (this.price.innerHTML = this.priceFormatter(
          Number(this.selectedVariant.price) / 100
        ))
      : "";
      this.fixedPrice ? (this.fixedPrice.innerHTML = this.priceFormatter(
        Number(this.selectedVariant.price) / 100
      )) : "";
    this.compare_price
      ? (this.compare_price.innerHTML = this.priceFormatter(
          Number(this.selectedVariant.compare_at_price) / 100
        ))
      : "";
    let discountVal =
      Number(this.selectedVariant.compare_at_price) >
      Number(this.selectedVariant.price)
        ? ((Number(this.selectedVariant.compare_at_price) -
            Number(this.selectedVariant.price)) /
            Number(this.selectedVariant.compare_at_price)) *
          100
        : "";
    this.discount
      ? (this.discount.innerText = this.discount.innerText.replace(
          /\d+/,
          discountVal.toFixed()
        ))
      : "";
  },
  registerUiComp() {
    this.sku = this.product.querySelector(".product-sku");
    this.compare_price = this.product.querySelector(".compare-price s");
    this.price = this.product.querySelector(".sale-price") || this.product.querySelector(".actual-price");
    this.discount = this.product.querySelector(".product-discount p");
    console.log('price element ', this.price);
  },
  priceFormatter(amount) {
    let formatter = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: Shopify.currency.active,
    });
    return formatter.format(amount);
  },
};
let product = document.querySelector(".product-container");
product ? ProductForm.initForm(product) : "";
